import { render, staticRenderFns } from "./GroupDistributionRootView.vue?vue&type=template&id=51b3ad08"
import script from "./GroupDistributionRootView.vue?vue&type=script&lang=js"
export * from "./GroupDistributionRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports